import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import ImageWithBasePath from '../../../../core/common/imageWithBasePath'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import { all_routes } from '../../../router/all_routes'
import { getCourses, Course, getCategories, Category } from '../../../../api/courses'
import { calculateDiscount, rupiahFormatter } from '../../../../utils/helpers'
import { getAdminFavoriteOverride } from '../../../../utils/favoriteStore'
import { useQuery } from '@tanstack/react-query'

interface FeaturedcourseProps {
  type?: 'Course' | 'Live_Teaching' | 'CBT'
  title?: string
  subtitle?: string
  limit?: number
}

const Featuredcourse = ({
  type = 'Course',
  title = 'Kelas E-Course Jadipraktisi',
  subtitle = 'Belajar Apa Saja Sesuai Kompetensi Yang Kamu Inginkan!',
  limit = 6,
}: FeaturedcourseProps) => {
  const [courses, setCourses] = useState<Course[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  // Countdown state untuk setiap item
  const [countdowns, setCountdowns] = useState<{
    [key: string]: {
      days: number
      hours: number
      minutes: number
      seconds: number
    }
  }>({})

  const [categories, setCategories] = useState<Category[]>([]);
  const [selectedCategory, setSelectedCategory] = useState<number>(0);

  //Feature Course Slider
  const featurecourseslider = {
    dots: true,
    infinite: courses.length > 3,
    speed: 300,
    slidesToShow: Math.min(3, courses.length),
    slidesToScroll: 1,
    centerMode: false,
    centerPadding: '0px',
    variableWidth: courses.length < 3,
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: Math.min(3, courses.length),
          slidesToScroll: 1,
          centerMode: false,
          centerPadding: '0px',
          variableWidth: courses.length < 3,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: Math.min(2, courses.length),
          slidesToScroll: 1,
          centerMode: false,
          centerPadding: '0px',
          variableWidth: courses.length < 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false,
          centerPadding: '0px',
          variableWidth: false,
        },
      },
    ],
  }

  const categoriescourseslider = {
    dots: false,
    infinite: categories.length > 3,
    speed: 300,
    slidesToShow: 6,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '40px',
    variableWidth: true,

    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 6,
          centerMode: true,
          centerPadding: '40px',
          variableWidth: true,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 4,
          centerMode: true,
          centerPadding: '30px',
          variableWidth: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          centerMode: true,
          centerPadding: '20px',
          variableWidth: true,
        },
      },
    ],
  };

  // Countdown effect untuk semua item
  useEffect(() => {
    const timer = setInterval(() => {
      const now = new Date().getTime()
      const newCountdowns: {
        [key: string]: {
          days: number
          hours: number
          minutes: number
          seconds: number
        }
      } = {}

      // Hitung countdown untuk setiap item Live_Teaching
      courses.forEach((course: any) => {
        if (course.start_date && type === 'Live_Teaching') {
          const startDate = new Date(course.start_date).getTime()
          const timeLeft = startDate - now

          if (timeLeft > 0) {
            const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24))
            const hours = Math.floor(
              (timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
            )
            const minutes = Math.floor(
              (timeLeft % (1000 * 60 * 60)) / (1000 * 60),
            )
            const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000)

            newCountdowns[course.id] = { days, hours, minutes, seconds }
          } else {
            newCountdowns[course.id] = {
              days: 0,
              hours: 0,
              minutes: 0,
              seconds: 0,
            }
          }
        }
      })

      setCountdowns(newCountdowns)
    }, 1000)

    return () => clearInterval(timer)
  }, [courses, type])

  const fetchCategories = async () => {
    const res = await getCategories({ page: 1, limit: 100, type: 'course' });
    setCategories(res?.data);
  }

  const handleSelectCategories = async (id: number) => {
    setSelectedCategory(id);
  }

  const fetchCourses = async () => {
    try {
      setLoading(true)
      setError(null)

      if (type === 'Course' && categories.length === 0) {
        fetchCategories();
      }

      const response = await getCourses({
        limit,
        page: 1,
        type,
        category: selectedCategory
      })
      setCourses(response.data)
    } catch (err) {
      setError('Gagal memuat data kursus')
      console.error('Error fetching courses:', err)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchCourses()
  }, [type, limit, selectedCategory])

  const route = all_routes
  return (
    <>
      {/* Add custom styles for consistent heights */}
      <style>
        {`
          .featured-courses-section .slick-slide > div {
            height: 100%;
          }
          .featured-courses-section .course-item {
            height: 100% !important;
            min-height: 450px;
          }
          .featured-courses-section .course-img {
            border-radius: 8px 8px 0 0;
          }
          .featured-courses-section .slick-track {
            display: flex;
            align-items: stretch;
          }
          .featured-courses-section .slick-slide {
            ${courses.length < 3
            ? `
              width: 350px !important;
              max-width: 350px;
              margin-right: 20px;
            `
            : ''
          }
          }
          ${courses.length < 3
            ? `
            .featured-courses-section .slick-list {
              padding: 0;
            }
            .featured-courses-section .slick-track {
              justify-content: center;
              margin-left: auto;
              margin-right: auto;
            }
          `
            : ''
          }
          ${courses.length === 1
            ? `
            .featured-courses-section .slick-track {
              justify-content: center;
            }
          `
            : ''
          }
          ${courses.length === 2
            ? `
            .featured-courses-section .slick-track {
              justify-content: center;
              gap: 20px;
            }
          `
            : ''
          }
        `}
      </style>
      {/* featured course */}
      <section className={`featured-courses-section live-teaching-bg`}>
        <div className="container">
          <div className="section-header d-flex align-items-center justify-content-between" style={{ marginBottom: '24px' }}>
            <h4 className='text-yellow'>{title}</h4>

            {/* Link */}
            <Link to={type === 'Live_Teaching' ? all_routes.liveTeaching : type === 'Course' ? all_routes.jadiCourse : all_routes.jadiUkom} className='text-white fw-medium' style={{ fontSize: '20px' }}>Lihat Semua</Link>
          </div>

          {/* Category Slider */}
          {categories.length > 0 && (
            <div className='categories-slider' style={{ marginBottom: '24px' }}>
              <Slider {...categoriescourseslider}>
                {categories.map((category, index) => (
                  <div onClick={() => handleSelectCategories(category.id)} key={category.id} style={{ width: "auto", display: "inline-block" }}>
                    <div className={`category-badge ${category.id === selectedCategory ? 'category-badge-active' : ''}`} style={{ cursor: 'pointer' }}>
                      {category.name}
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          )}

          <div className="feature-course-slider-22 top-courses-slider">
            {loading ? (
              <div className="text-center py-5">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
                <p className="mt-3">Memuat kursus...</p>
              </div>
            ) : error ? (
              <div className="text-center py-5">
                <div className="alert alert-danger" role="alert">
                  {error}
                </div>
                <button
                  className="btn btn-primary"
                  onClick={() => window.location.reload()}
                >
                  Coba Lagi
                </button>
              </div>
            ) : courses.length === 0 ? (
              <div className="text-center py-5">
                <div className="alert alert-info" role="alert">
                  <i className="fa-solid fa-info-circle me-2"></i>
                  Belum ada{' '}
                  {type === 'Course'
                    ? 'kursus'
                    : type === 'Live_Teaching'
                      ? 'kelas live teaching'
                      : 'CBT'}{' '}
                  yang tersedia saat ini.
                </div>
              </div>
            ) : (
              <Slider {...featurecourseslider}>
                {courses.map((course, index) => (
                  <div key={course.id}>
                    <div
                      className="course-item-two course-item mx-0"
                      style={{
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        width: courses.length < 3 ? '350px' : 'auto',
                        maxWidth: courses.length < 3 ? '350px' : 'none',
                        borderRadius: '20px'
                      }}
                    >
                      <div className={`position-relative ${type === 'Live_Teaching' ? '' : 'course-img'}`}>
                        <Link
                          to={`${type === 'Course'
                            ? route.jadiCourseDetail
                            : type === 'Live_Teaching'
                              ? route.liveTeachingDetail
                              : route.jadiUkomDetail
                            }`.replace(':id', course.id.toString())}
                        >
                          <ImageWithBasePath
                            src=""
                            srcApi={course.image || course.poster}
                            alt={course.title}
                            className="img-fluid"
                            isLandscape={false}
                            style={{ borderRadius: '20px' }}
                          />
                        </Link>
                        {Boolean(
                          (getAdminFavoriteOverride(course.id) !== null ? getAdminFavoriteOverride(course.id) : (course as any).is_favorite || (course as any).is_bestseller || (course as any).badge === 'bestseller')
                        ) && (
                          <div
                            className="position-absolute"
                            style={{
                              top: '-2px',
                              left: '-2px',
                              zIndex: 15,
                              pointerEvents: 'none',
                            }}
                          >
                            <div className="d-inline-flex flex-column align-items-start">
                              <span
                                className="badge text-white fw-bold d-inline-flex align-items-center gap-1.5 shadow"
                                style={{
                                  background: "linear-gradient(135deg, #48bb78 0%, #276749 100%)",
                                  borderRadius: "8px 22px 22px 0px",
                                  fontSize: "12.5px",
                                  fontWeight: 800,
                                  padding: "6px 16px 6px 12px",
                                  boxShadow: "0 4px 12px rgba(39, 103, 73, 0.45)",
                                  letterSpacing: "0.3px",
                                  color: "#ffffff",
                                  textShadow: "0 1px 2px rgba(0, 0, 0, 0.2)",
                                }}
                              >
                                <i className="fa-solid fa-crown text-white me-1 fs-12" style={{ filter: "drop-shadow(0 1px 1px rgba(0,0,0,0.2))" }} />
                                <span>Best Seller</span>
                              </span>
                              {/* 3D Ribbon Fold Triangle */}
                              <div
                                style={{
                                  width: 0,
                                  height: 0,
                                  borderTop: "5px solid #1c4532",
                                  borderLeft: "5px solid transparent",
                                  marginTop: "-1px",
                                }}
                              />
                            </div>
                          </div>
                        )}
                      </div>
                      <div
                        className="course-content"
                        style={{
                          flex: 1,
                          display: 'flex',
                          flexDirection: 'column',
                        }}
                      >
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <div className="d-flex align-items-center">
                            {course.start_date &&
                              course.end_date &&
                              type === 'Live_Teaching' && (
                                <>
                                  {(() => {
                                    const now = new Date().getTime()
                                    const startDate = new Date(
                                      course.start_date,
                                    ).getTime()
                                    const endDate = new Date(
                                      course.end_date,
                                    ).getTime()

                                    if (now > endDate) {
                                      return (
                                        <span className="badge mb-0 bg-info">
                                          Event Selesai
                                        </span>
                                      )
                                    }

                                    if (now >= startDate && now <= endDate) {
                                      return (
                                        <span className="badge mb-0 bg-success">
                                          Live Now
                                        </span>
                                      )
                                    }

                                    if (now < startDate) {
                                      const courseCountdown = countdowns[
                                        course.id
                                      ] || {
                                        days: 0,
                                        hours: 0,
                                        minutes: 0,
                                        seconds: 0,
                                      }

                                      // Tampilkan format yang berbeda berdasarkan jumlah hari
                                      let countdownText = ''
                                      if (courseCountdown.days > 0) {
                                        countdownText = `${courseCountdown.days
                                          } hari ${courseCountdown.hours
                                            .toString()
                                            .padStart(
                                              2,
                                              '0',
                                            )} : ${courseCountdown.minutes
                                              .toString()
                                              .padStart(
                                                2,
                                                '0',
                                              )} : ${courseCountdown.seconds
                                                .toString()
                                                .padStart(2, '0')}`
                                      } else {
                                        countdownText = `${courseCountdown.hours
                                          .toString()
                                          .padStart(
                                            2,
                                            '0',
                                          )} : ${courseCountdown.minutes
                                            .toString()
                                            .padStart(
                                              2,
                                              '0',
                                            )} : ${courseCountdown.seconds
                                              .toString()
                                              .padStart(2, '0')}`
                                      }

                                      return (
                                        <span className="badge mb-0 bg-warning">
                                          {countdownText}
                                        </span>
                                      )
                                    }
                                  })()}
                                </>
                              )}
                            {type === 'Course' && (
                              <>
                                <span className="badge mb-0 bg-info">
                                  {`${course.student_count || 0} Siswa`}
                                </span>
                              </>
                            )}
                            {type === 'CBT' && (
                              <>
                                <span className="badge mb-0 bg-info">
                                  {`${course.questions_count || 0} Soal`}
                                </span>
                              </>
                            )}
                          </div>
                          <span className="badge badge-light rounded-pill bg-light d-inline-flex align-items-center fs-13 fw-medium mb-0">
                            {course.category.name}
                          </span>
                        </div>
                        <h6
                          className="title mb-2"
                          style={{
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            lineHeight: '1.4',
                            minHeight: '2.8em',
                            maxHeight: '2.8em',
                          }}
                        >
                          <Link
                            to={`${type === 'Course'
                              ? route.jadiCourseDetail
                              : type === 'Live_Teaching'
                                ? route.liveTeachingDetail
                                : route.jadiUkomDetail
                              }`.replace(':id', course.id.toString())}
                          >
                            {course.title}
                          </Link>
                        </h6>
                        <div className="d-flex align-items-center">
                          <div className="price">
                            {!!course?.discount_type ? (
                              <h5 className='text-primary' style={{ fontSize: '25px' }}>
                                {calculateDiscount(
                                  parseInt(course?.price || '0'),
                                  course?.discount,
                                  course?.discount_type,
                                )}{' '}
                                <span style={{ fontSize: '15px', color: '#0000004D' }}>
                                  {rupiahFormatter(
                                    parseInt(course?.price || '0'),
                                  )}
                                </span>
                              </h5>
                            ) : (
                              <h5 className='text-primary' style={{ fontSize: '25px' }}>
                                {rupiahFormatter(
                                  parseInt(course?.price || '0'),
                                )}{' '}
                              </h5>
                            )}
                          </div>
                        </div>
                        <Link
                          to={`${type === 'Course'
                            ? route.jadiCourseDetail
                            : type === 'Live_Teaching'
                              ? route.liveTeachingDetail
                              : route.jadiUkomDetail
                            }`.replace(':id', course.id.toString())}
                          className="btn btn-dark btn-sm d-inline-flex align-items-center mt-2 fw-bold"
                          style={{
                            width: 'fit-content',
                            borderRadius: '5px'
                          }}
                        >
                          {type === 'Live_Teaching' ? 'Lihat Kelas' : 'Lihat Detail'}
                          {type !== 'Live_Teaching' && (
                            <i className="isax isax-arrow-right-3 ms-1" />
                          )}
                        </Link>
                      </div>
                    </div>
                  </div>
                ))}
              </Slider>
            )}
          </div>
          <div className="d-flex align-items-center justify-content-center">
            {/* <Link
              to={
                type === 'Course'
                  ? route.jadiCourse
                  : type === 'Live_Teaching'
                    ? route.liveTeaching
                    : route.jadiUkom
              }
              className="btn btn-primary btn-md"
            >
              View All{' '}
              {type === 'Course'
                ? 'Courses'
                : type === 'Live_Teaching'
                  ? 'Live Teaching'
                  : 'CBT'}
            </Link> */}
          </div>
        </div>
      </section>
      {/* /featured course */}
    </>
  )
}

export default Featuredcourse